import React from "react";
import MejorateQuiz from "./MejorateQuiz";

const preguntasBenzodiazepina = [
  //Pregunta 1
  {
    question:
      "¿Cuánto tiempo de uso de benzodiacepinas se considera seguro antes de que aumenten los riesgos de efectos secundarios graves?",
    options: ["1 año", "6 meses", "3 meses", "4 semanas"],
    correctAnswerIndex: 3,
  },
  // Pregunta 2
  {
    question:
      "¿Cuál es uno de los riesgos más significativos del uso prolongado de benzodiacepinas?",
    options: [
      "Aumento de la energía",
      "Dependencia y síndrome de abstinencia",
      "Mejora en la función respiratoria",
      "Mayor capacidad de aprendizaje",
    ],
    correctAnswerIndex: 1,
  },
  // Pregunta 3
  {
    question:
      "¿Qué ocurre si se intenta reducir o detener abruptamente el consumo de benzodiacepinas después de un uso prolongado?",
    options: [
      "Desaparecen los síntomas de ansiedad",
      "Se mejora la función cognitiva",
      "Se experimentan síntomas de abstinencia",
      "Se reduce el riesgo de desrealización",
    ],
    correctAnswerIndex: 2,
  },
  // Pregunta 4
  {
    question:
      "¿Cuál puede ser la duración del síndrome de abstinencia tras el uso prolongado de benzodiacepinas?",
    options: [
      "De uno a cinco días",
      "De una a dos semanas",
      "De tres a seis meses",
      "Desde dos semanas hasta más de un año",
    ],
    correctAnswerIndex: 3,
  },
  // Pregunta 5
  {
    question:
      "¿Cuál de los siguientes síntomas es un posible efecto del síndrome de abstinencia de benzodiacepinas?",
    options: [
      "Náuseas intensas",
      "Picores",
      "Despersonalización y desrealización",
      "Diarrea persistente",
    ],
    correctAnswerIndex: 2,
  },
  // Pregunta 6
  {
    question:
      "¿Cuál es una de las consecuencias psicológicas graves que pueden presentarse durante el síndrome de abstinencia severo de benzodiacepinas?",
    options: [
      "Aumento en la creatividad",
      "Mejora del estado de ánimo",
      "Psicosis y delirium tremens",
      "Incremento en la concentración",
    ],
    correctAnswerIndex: 2,
  },
  // Pregunta 7
  {
    question:
      "¿Qué tipo de cambios pueden experimentarse durante el síndrome de abstinencia de benzodiacepinas?",
    options: [
      "Mejora en la capacidad de coordinación motora",
      "Disminución de los niveles de estrés",
      "Alteraciones auditivas, visuales y sensoriales",
      "Aumento de la claridad mental y la concentración",
    ],
    correctAnswerIndex: 2,
  },
  // Pregunta 8
  {
    question:
      "¿Cuál de los siguientes efectos es común en el síndrome de abstinencia de las benzodiacepinas?",
    options: [
      "Disminución de la ansiedad",
      "Convulsiones",
      "Mejora de la concentración",
      "Aumento de la memoria",
    ],
    correctAnswerIndex: 1,
  },
  // Pregunta 9
  {
    question:
      "¿Qué condiciones psicológicas y emocionales pueden aparecer y/o intensificarse con el uso prolongado de benzodiacepinas?",
    options: [
      "Sentimientos de euforia y entusiasmo",
      "Un aumento de la empatía",
      "La disminución de la hiperactividad",
      "Ansiedad, depresión e insomnio",
    ],
    correctAnswerIndex: 3,
  },
  // Pregunta 10
  {
    question:
      "¿Qué efecto puede verse particularmente pronunciado en adultos mayores por el uso prolongado de benzodiacepinas?",
    options: [
      "Aumento de la energía",
      "Mejora de la concentración",
      "Deterioro cognitivo y riesgo de demencia",
      "Mayor agilidad física",
    ],
    correctAnswerIndex: 2,
  },
  // Pregunta 11
  {
    question:
      "¿Qué tipo de variaciones cognitivas pueden experimentar los consumidores de benzodiacepinas?",
    options: [
      "Aumento en la creatividad y habilidades de cálculo",
      "Mejor concentración y capacidad de organización",
      "Dificultades con la atención, la memoria, el aprendizaje y la función ejecutiva",
      "Incremento en la velocidad de procesamiento y memoria",
    ],
    correctAnswerIndex: 2,
  },
  // Pregunta 12
  {
    question:
      "¿Cuál de los siguientes grupos de personas tiene mayor riesgo de sufrir alteraciones de comportamiento al consumir benzodiacepinas?",
    options: [
      "Personas con ansiedad leve",
      "Personas con depresión leve",
      "Personas con trastornos de personalidad límite",
      "Personas con insomnio ocasional",
    ],
    correctAnswerIndex: 2,
  },
  // Pregunta 13
  {
    question:
      "¿Qué efectos pueden tener las benzodiacepinas cuando se combinan con alcohol?",
    options: [
      "Aumento de la coordinación motora y mayor resistencia física",
      "Ansiedad, excitación, hiperactividad y agresividad",
      "Mejora del equilibrio y rapidez en la toma de decisiones",
      "Aumento de reflejos, mejora en la coordinación y claridad mental",
    ],
    correctAnswerIndex: 1,
  },
  // Pregunta 14
  {
    question:
      "¿Qué condición preexistente aumenta el riesgo de depresión respiratoria con el uso de benzodiacepinas?",
    options: [
      "Diabetes",
      "Hipertensión",
      "Problemas de sueño",
      "Problemas respiratorios",
    ],
    correctAnswerIndex: 3,
  },
  // Pregunta 15
  {
    question:
      "¿Qué otro tipo de medicamentos, además de los opioides, aumenta el riesgo de depresión respiratoria y sobredosis al combinarse con benzodiacepinas?",
    options: [
      "Medicamentos antiinflamatorios no esteroideos (AINEs)",
      "Antihipertensivos",
      "Otros depresores del sistema nervioso central",
      "Antibióticos de amplio espectro",
    ],
    correctAnswerIndex: 2,
  },
  // Pregunta 16
  {
    question:
      "¿Qué complicación puede surgir si se usan benzodiacepinas durante el embarazo?",
    options: [
      "Mejor desarrollo neurológico en el feto",
      "Reducción de síntomas de abstinencia neonatal",
      "Malformaciones congénitas",
      "Disminución del riesgo de parto prematuro",
    ],
    correctAnswerIndex: 2,
  },
  // Pregunta 17
  {
    question:
      "¿Cuál de las siguientes opciones está asociada al uso de benzodiacepinas durante el embarazo?",
    options: [
      "Fortalecimiento del sistema inmunológico y desarrollo avanzado del feto",
      "Problemas neurológicos y síntomas de abstinencia neonatal",
      "Reducción de problemas digestivos y menor riesgo de alergias",
      "Disminución del riesgo de parto prematuro",
    ],
    correctAnswerIndex: 1,
  },
  // Pregunta 18
  {
    question:
      "¿Qué puede ocurrir cuando se combinan benzodiacepinas con opioides?",
    options: [
      "Aumento del riesgo de sobredosis",
      "Mejora de la función cognitiva",
      "Aumento en la energía",
      "Reducción del dolor sin riesgo adicional",
    ],
    correctAnswerIndex: 0,
  },
  // Pregunta 19
  {
    question:
      "¿Qué efecto en la salud física es común entre los consumidores de benzodiacepinas?",
    options: [
      "Aumento en la velocidad de respuesta",
      "Mejora en la coordinación motora",
      "Sedación y somnolencia",
      "Mayor agudeza visual",
    ],
    correctAnswerIndex: 2,
  },
  // Pregunta 20
  {
    question:
      "¿Qué aspecto de la vida cotidiana puede verse afectado debido a la sedación provocada por las benzodiacepinas?",
    options: [
      "Mayor productividad laboral",
      "Mejor equilibrio emocional",
      "Conducción de vehículos",
      "Capacidad de cálculo mental",
    ],
    correctAnswerIndex: 2,
  },
  // Pregunta 21
  {
    question:
      "¿Qué condición de salud física es común en usuarios de benzodiacepinas debido a problemas de coordinación?",
    options: [
      "Riesgo de caídas y fracturas",
      "Reducción de la somnolencia",
      "Mejor desempeño físico",
      "Aumento de la coordinación motora",
    ],
    correctAnswerIndex: 0,
  },
  // Pregunta 22
  {
    question:
      "¿Cuál es una de las consecuencias del uso prolongado de benzodiacepinas en el entorno laboral?",
    options: [
      "Mejora en el rendimiento laboral",
      "Deterioro en el rendimiento y relaciones laborales",
      "Aumento de la eficiencia",
      "Mejor enfoque en tareas",
    ],
    correctAnswerIndex: 1,
  },
  // Pregunta 23
  {
    question:
      "¿Cuál es un posible efecto del uso prolongado de benzodiacepinas en el ámbito laboral?",
    options: [
      "Pérdida de productividad debido a problemas de atención y memoria",
      "Aumento de la proactividad en el trabajo",
      "Mejor adaptación a tareas de alta presión",
      "Incremento en la resistencia al estrés",
    ],
    correctAnswerIndex: 0,
  },
  // Pregunta 24
  {
    question:
      "¿Qué efecto cognitivo puede tener el uso prolongado de benzodiacepinas en el ámbito académico?",
    options: [
      "Mejor capacidad de retención",
      "Dificultad en la memoria y el aprendizaje",
      "Mayor rapidez en el aprendizaje",
      "Aumento en la atención a detalles",
    ],
    correctAnswerIndex: 1,
  },
  // Pregunta 25
  {
    question:
      "¿Qué factores aumentan significativamente el riesgo de efectos adversos al consumir benzodiacepinas?",
    options: [
      "La frecuencia de ejercicio físico y la dieta",
      "La ocupación y el nivel educativo",
      "La duración del consumo, la edad y el consumo de otras sustancias",
      "La cantidad de horas de sueño y la exposición al sol",
    ],
    correctAnswerIndex: 2,
  },
];

export default function MejorateBenzodiazepina() {
  return (
    <MejorateQuiz
      quizType="Benzodiazepinas"
      questions={preguntasBenzodiazepina}
    />
  );
}
